import { dateRangeFromISO, getDateRange } from "@app/lib/date-range";
import { getPerspectiveId } from "@app/lib/perspective";
import StakeholderDetailPage, {
  stakeholderDetailQuery,
} from "@app/pages/stakeholder-detail/stakeholder-detail-page";
import type { stakeholderDetailPage_Query } from "@app/queries/stakeholderDetailPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/stakeholders_/$stakeholderId")({
  validateSearch: (search: Record<string, unknown>): { month?: string } => ({
    month: typeof search.month === "string" ? search.month : undefined,
  }),
  loaderDeps: ({ search }) => search,
  loader: ({ params, deps }) =>
    loadQuery<stakeholderDetailPage_Query>(
      environment,
      stakeholderDetailQuery,
      {
        stakeholderId: params.stakeholderId,
        month: deps.month,
        perspectiveId: getPerspectiveId() ?? undefined,
        from: dateRangeFromISO(getDateRange()) ?? undefined,
      },
      { fetchPolicy: "network-only" }
    ),
  head: ({ params }) => pageHead(`Stakeholder ${params.stakeholderId}`),
  component: StakeholderDetailRoute,
});

function StakeholderDetailRoute() {
  const queryRef = Route.useLoaderData();
  const { stakeholderId } = Route.useParams();
  const { month } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">Error loading counterparty</div>
      }
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">Loading counterparty...</div>
        }
      >
        <StakeholderDetailPage
          queryRef={queryRef}
          stakeholderId={stakeholderId}
          month={month}
          onMonthChange={(next) => navigate({ search: { month: next } })}
        />
      </Suspense>
    </ErrorBoundary>
  );
}
